import React, { useEffect } from "react";

import { handleCaptchaPair } from 'utils/captchaPair';
import HOC from './action';
import './index.scss';

const FriendlyCaptcha = props => {
	let { style, onHandleDone, onHandleError, captchaVerification } = props
	const { useCaptchaHook  } = require( "@aacn.eu/use-friendly-captcha" )
	const captchaHook = useCaptchaHook({
		siteKey: handleCaptchaPair().sitekey,
		endpoint: "EU1",
		language: props.lang || 'en',
		startMode: "focus",
		showAttribution: true,
	});

	useEffect(() => {
		if (captchaHook.captchaStatus.solution) {
			captchaVerification( captchaHook.captchaStatus.solution )
			onHandleDone(captchaHook.captchaStatus.solution);
		} else if (captchaHook.captchaStatus.error) {
			onHandleError(captchaHook.captchaStatus.error);
		}
	}, [captchaHook.captchaStatus]);

	return (
		<div style={{ ...style }} className="card ark-captcha-card p-2">
			{captchaHook.CaptchaWidget({
				className: "min-w-full pl-2 pb-1 mt-6 bg-cyan-800 rounded",
			})}
		</div>
	);
};

export default HOC(FriendlyCaptcha);
